import React from "react";
import { LazyAutoplayVideo } from "../visuals/LazyAutoplayVideo";
import { Box } from "@chakra-ui/react";
import { useLandingTheme } from "../LandingThemeContext";
import { useLandingCopy } from "../LandingLanguageContext";
import { ContentContainer, SectionHeading } from "./shared";

const VIDEO_SRC = "https://d2hnj1wejf84km.cloudfront.net/grow-trees.mp4";

export default function GrowTreesSection() {
  const theme = useLandingTheme();
  const growTreesCopy = useLandingCopy().growTrees;
  const isOriginal = theme.id === "original";
  // The Original stays a pixel match of Framer; Moss gets 32px more breathing room above the heading.
  const sectionTopPadding = isOriginal
    ? { base: "103px", md: "112px", lg: "92px" }
    : { base: "135px", md: "144px", lg: "124px" };
  return (
    <Box as="section" pt={sectionTopPadding}>
      <ContentContainer>
        <SectionHeading maxW="700px" mx="auto" mb="32px">
          {growTreesCopy.heading}
        </SectionHeading>
        <Box
          borderRadius={isOriginal ? "20px" : theme.shape.cardRadius}
          overflow="hidden"
          border={isOriginal ? "none" : theme.card.border}
          boxShadow={isOriginal ? "0 10px 40px rgba(0, 0, 0, 0.06)" : theme.card.shadow}
        >
          <LazyAutoplayVideo
            src={VIDEO_SRC}
            poster="/images/landing/grow-trees-poster.webp"
            width={1746}
            height={1080}
            style={{ width: "100%", height: "auto", aspectRatio: "1746 / 1080", display: "block" }}
          />
        </Box>
      </ContentContainer>
    </Box>
  );
}
